import { PropTypes } from 'prop-types';
import React from 'react';

import { transformArticleData } from '../../utils';
import CardImageBasedSmall from '../Cards/CardImageBased/CardImageBasedSmall';
import CardTextBasedMedium from '../Cards/CardTextBased/CardTextBasedMedium';
import CardTextBasedSmallHighlight from '../Cards/CardTextBased/CardTextBasedSmallHighlight';
import CardTextBasedXSmall from '../Cards/CardTextBased/CardTextBasedXSmall';

const HomepageMosaic = ({ mosaic, mosaicQuote, variant }) => {
  // split into 3 main chunks
  return (
    <div className="grid lg:grid-cols-13 sm:grid-rows-[auto,1fr] homepage-grid-gaps gap-y-8 lg:h-full sm:grid-cols-2 lg:px-0 sm:px-10 px-6 mt-14 lg:mt-0">
      {/* chunk-1: two image cards */}
      <div className="grid order-1 h-auto grid-cols-2 lg:grid-cols-1 lg:order-1 sm:order-3 lg:col-span-5 lg:row-span-2 sm:row-span-1 gap-y-8 homepage-grid-gaps">
        {mosaic.slice(0, 2).map((item, index) => {
          const {
            cardImage,
            franchise,
            header,
            id,
            publishedDate,
            slug,
            tags,
            title,
          } = transformArticleData(item);
          const cardImageBasedSmall = (
            <CardImageBasedSmall
              key={id}
              date={publishedDate}
              franchise={franchise}
              header={header}
              image={cardImage}
              imageClassName="h-32 lg:h-full"
              imageResponsive
              size="medium"
              slug={slug}
              tags={tags}
              title={title}
            />
          );
          const cardTextBasedSmallHighlight = (
            <div
              key={id}
              className="sm:h-full lg:min-h-[360px] sm:min-h-[240px]"
            >
              <CardTextBasedSmallHighlight
                date={publishedDate}
                slug={slug}
                tags={tags}
                title={title}
              />
            </div>
          );
          switch (index) {
            case 0:
              return cardImageBasedSmall;

            case 1:
              return variant
                ? cardTextBasedSmallHighlight
                : cardImageBasedSmall;

            default:
              return null;
          }
        })}
      </div>
      {/* chunk-2: quote */}
      <div className="order-2 row-span-1 lg:order-2 lg:col-span-8">
        <CardTextBasedMedium
          author={mosaicQuote?.author}
          link={mosaicQuote?.link}
          title={mosaicQuote?.title}
        />
      </div>
      {/* chunk-3: two image cards, two text cards  */}
      <div className="homepage-grid-gaps h-[fit-content] sm:gap-y-8 order-3 lg:h-auto lg:row-span-1 sm:order-2 sm:row-span-2 lg:order-3 lg:col-span-8 grid sm:grid-rows-[auto,1fr,auto] grid-cols-2">
        {mosaic.slice(2).map((item, index) => {
          const { cardImage, franchise, id, publishedDate, slug, tags, title } =
            transformArticleData(item);
          const imageCard = (
            <CardImageBasedSmall
              date={publishedDate}
              franchise={franchise}
              image={cardImage}
              imageClassName="h-32 lg:h-full image-hover"
              imageResponsive
              slug={slug}
              tags={tags}
              title={title}
            />
          );
          const textCard = (
            <CardTextBasedXSmall
              className={
                index === 2
                  ? 'flex flex-col pt-6 pb-8 border-t sm:pt-8 sm:border-b border-smoke'
                  : undefined
              }
              date={publishedDate}
              slug={slug}
              title={title}
            />
          );
          switch (index) {
            case 0:
              return (
                <div key={id} className="sm:order-1 sm:row-span-2">
                  {imageCard}
                </div>
              );
            case 1:
              return (
                <div key={id} className="sm:order-3 sm:row-span-2">
                  {imageCard}
                </div>
              );
            case 2:
              return (
                <div
                  key={id}
                  className="col-span-2 mt-8 sm:col-span-1 sm:order-2 sm:row-span-1 sm:mt-0"
                >
                  {textCard}
                </div>
              );
            case 3:
              return (
                <div
                  key={id}
                  className="col-span-2 sm:col-span-1 sm:order-4 sm:row-span-1"
                >
                  {textCard}
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

HomepageMosaic.propTypes = {
  mosaic: PropTypes.array,
  mosaicQuote: PropTypes.object,
  variant: PropTypes.bool,
};

export default HomepageMosaic;
